export const populatePokemons = (pokemons) => ({
    type: 'POPULATE_POKEMONS',
    pokemons
});

export const setFilter = (filter) => ({
    type: 'SET_FILTER',
    filter
});

export const setCount = (count) => ({
    type: 'SET_COUNT',
    count
});

export const pokemonData = (pokemon) => ({
    type: 'POKEMON_DATA',
    pokemon
});